import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { connect } from "react-redux";

import "./SignupCard.component.scss";
import SignupForm from "./SignupForm/SignupForm.component";
import { ActionCreator } from "../../../../../actions/actions";
import { AuthActionCreators } from "../../../actions/actionCreators";

export interface SignupCardProps {
    signup: ActionCreator;
    suggestion: any;
    onChangePage: any;
}

class SignupCard extends Component<SignupCardProps, {}> {
    render() {
        return (
            <div id="SignupCard">
                <div>
                    <div className="title-1">Welcome to Wave</div>
                    <div className="title-2">Create your account</div>

                    <SignupForm
                        onSubmit={this.props.signup}
                        onChangePage={this.props.onChangePage}
                    />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    signup: AuthActionCreators.signup
};

export default connect(
    null,
    mapDispatchToProps
)(SignupCard);
